/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_How_Heard_Other_LabelInputs */

const en_us2_onboarding_how_heard_other_label = /** @type {(inputs: Onboarding_How_Heard_Other_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where? (optional)`)
};

const pt_br2_onboarding_how_heard_other_label = /** @type {(inputs: Onboarding_How_Heard_Other_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onde? (opcional)`)
};

const es_419_onboarding_how_heard_other_label = /** @type {(inputs: Onboarding_How_Heard_Other_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Dónde? (opcional)`)
};

const pt_pt2_onboarding_how_heard_other_label = /** @type {(inputs: Onboarding_How_Heard_Other_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onde? (opcional)`)
};

const fr_fr2_onboarding_how_heard_other_label = /** @type {(inputs: Onboarding_How_Heard_Other_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Où ? (facultatif)`)
};

const de_de2_onboarding_how_heard_other_label = /** @type {(inputs: Onboarding_How_Heard_Other_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wo? (optional)`)
};

const it_it2_onboarding_how_heard_other_label = /** @type {(inputs: Onboarding_How_Heard_Other_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dove? (facoltativo)`)
};

/**
* | output |
* | --- |
* | "Where? (optional)" |
*
* @param {Onboarding_How_Heard_Other_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_how_heard_other_label = /** @type {((inputs?: Onboarding_How_Heard_Other_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_How_Heard_Other_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_how_heard_other_label(inputs)
	if (locale === "es-419") return es_419_onboarding_how_heard_other_label(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_how_heard_other_label(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_how_heard_other_label(inputs)
	if (locale === "de-DE") return de_de2_onboarding_how_heard_other_label(inputs)
	if (locale === "it-IT") return it_it2_onboarding_how_heard_other_label(inputs)
	return en_us2_onboarding_how_heard_other_label(inputs)
});
export { onboarding_how_heard_other_label as "onboarding.how_heard.other_label" }